import { render, staticRenderFns } from "./p-landing-page-a.vue?vue&type=template&id=edd56344&"
import script from "./p-landing-page-a.vue?vue&type=script&lang=js&"
export * from "./p-landing-page-a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports